/** @jsx jsx */
import { jsx } from "theme-ui";
import React from "react";
import { getSrcSet } from "@builder.io/react";

type objectFit = "fill" | "contain" | "cover" | "none" | "scale-down";

export type BuilderImageProps = {
  url: string;
  alt: string;
  lazy: boolean;
  backgroundSize?: objectFit;
  backgroundPosition?: string;
  fetchPriority?: "high" | "low" | "auto";
  aspectRatio: string;
  className?: string;
  title?: string;
  width?: string;
  height?: string;
};
export const BuilderImage: React.FC<BuilderImageProps> = ({
  url,
  alt,
  lazy,
  backgroundSize,
  backgroundPosition,
  fetchPriority = "auto",
  aspectRatio,
  className,
  title,
  width,
  height,
}) => {
  const srcset = getSrcSet(url);

  return (
    <picture>
      {srcset && srcset.match(/builder\.io/) && (
        <source
          srcSet={srcset.replace(/\?/g, "?format=webp&")}
          type="image/webp"
        />
      )}
      <img
        alt={alt}
        role={!alt ? "presentation" : undefined}
        loading={lazy ? "lazy" : "eager"}
        src={url}
        srcSet={srcset}
        fetchpriority={fetchPriority}
        title={title || alt}
        height={height}
        width={width}
        css={{
          transition: "opacity 0.2s ease-in-out",
          objectFit: backgroundSize || "cover",
          objectPosition: backgroundPosition || "center",
          aspectRatio: aspectRatio, //used for CLS
          width: "100%", //used for CLS
        }}
        className={className}
      />
    </picture>
  );
};

export default BuilderImage;
